import "./AverageSpendChart.scss";
import {
  ResponsiveContainer,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";
import AverageSpendChartLogic from "./AverageSpendChartLogic";
import { formatCurrency } from "../../../helpers";
import secondaryComponents from "..";
import Images from "../../../assets/images";
import { useSelector } from "react-redux";

const AverageSpendChart = ({ ASPUCustomerData }) => {
  const { xAxisFormatter } = AverageSpendChartLogic();
  const { currency_code } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );

  return (
    <div className="average-spend-chart">
      <div className="average-spend-chart__header">
        <h4 style={{ fontSize: "20px" }} className="font-weight-semibold">
          Average Spend per Customer
        </h4>
        <div className="text-center">
          <h4 className="font-weight-semibold">
            {formatCurrency({
              value: ASPUCustomerData.count,
              currencyCode: currency_code,
            })}
          </h4>
          {/* <span style={{ fontSize: "12px", color: "#19AE57" }}>
                        +14% from last week
                    </span> */}
        </div>
      </div>
      {ASPUCustomerData.trend.length > 0 ? (
        <ResponsiveContainer
          width={"100%"}
          aspect={2}
          margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
          className="average-spend-chart__main"
        >
          <BarChart width="auto" height={250} data={ASPUCustomerData.trend}>
            <CartesianGrid
              stroke="#E8E9EB"
              strokeDasharray="5 0"
              horizontal={true}
              vertical={false}
            />
            <XAxis
              tickLine={false}
              tick={{ fontSize: "10px" }}
              axisLine={false}
              dataKey="date"
              tickFormatter={xAxisFormatter}
            />
            <YAxis
              tick={{ fontSize: "10px" }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip
              wrapperStyle={{ border: "none", outline: "none" }}
              content={
                <secondaryComponents.CustomerChartTooltip isMoney={true} />
              }
            />
            <Bar dataKey="count" fill="#19AE57" barSize={35} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <div className="mt-5 text-center">
          <img
            width={"150px"}
            src={Images.customersEmptyState}
            alt="No transactions"
          />
          <p className="font-weight-semibold mt-3 dark--text">
            No data available
          </p>
        </div>
      )}
    </div>
  );
};

export default AverageSpendChart;
